import React, { PropsWithChildren } from 'react';
import { ItemWithIcon }             from "@src/views/components/display/ItemWithIcon";
import { Header, Icon, Segment }    from "semantic-ui-react";
import { FinePrintMessage }         from "@src/views/components/util/messaging/FinePrintMessage";


interface BulkUpdateAttributeInfoProps<T = never> extends PropsWithChildren<any> {
    title: string,
    description: string,
}

const BulkUpdateAttributeInfoDefaultProps = {} satisfies Partial<BulkUpdateAttributeInfoProps>

function BulkUpdateAttributeInfo<T>( { children, ...p }: BulkUpdateAttributeInfoProps<T> ){

    const props = { ...BulkUpdateAttributeInfoDefaultProps, ...p };

    return (
        <Segment size={ 'tiny' }>
            <Header as={ 'h5' } color={ 'purple' } icon={'info circle'}>{ props.title }</Header>
            <FinePrintMessage>{ props.description }</FinePrintMessage>
        </Segment>
    );
}

export {
    BulkUpdateAttributeInfo,
    BulkUpdateAttributeInfoDefaultProps,
    type BulkUpdateAttributeInfoProps,
};
